import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-freight",
  "use": "icon-freight-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-freight\"><path d=\"M928 768h-67.2c-12.8-54.4-64-96-124.8-96s-108.8 41.6-124.8 96h-201.6c-12.8-54.4-64-96-124.8-96S176 713.6 160 768H96v-278.4L211.2 288H352v160H256v64h128c19.2 0 32-12.8 32-32V160h224V96h-224c-35.2 0-64 28.8-64 64v64H211.2c-22.4 0-44.8 12.8-57.6 32l-118.4 208c-3.2 6.4-3.2 9.6-3.2 16v288c0 35.2 28.8 64 64 64h67.2c12.8 54.4 64 96 124.8 96s108.8-41.6 124.8-96h201.6c12.8 54.4 64 96 124.8 96s108.8-41.6 124.8-96h64c35.2 0 64-28.8 64-64v-224h-64v224zM288 864c-35.2 0-64-28.8-64-64s28.8-64 64-64 64 28.8 64 64-28.8 64-64 64z m448 0c-35.2 0-64-28.8-64-64s28.8-64 64-64 64 28.8 64 64-28.8 64-64 64z\" /><path d=\"M992 288V224h-115.2l96-96L928 83.2l-96 96-96-96L691.2 128l96 96H672v64h128v64h-128v64h128v128h64v-128h128v-64h-128V288z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/freight.svg
// module id = wbuy
// module chunks = 55